module.exports = __webpack_public_path__ + "static/favicon-c99f70740a0882f4f3a7a4a98a237b71.ico";